<template lang="pug">
  .garbage-operation.krasn.body.modal__row
    template(v-if="error")
      div.col
        div.col-block.partial-error {{error}}
    template(v-else)
      div.col.modal__col
        div.col-block
          label Категория
          select.select(
            name="garbage_source_category_id"
            v-model="model.garbage_source_category_id"
            @change="catHandler"
            :disabled="categoryDisabled"
          ).garbage-source-category
            option(value="" disabled) Выберите категорию
            option(
              v-for="cat in garbageCategory"
              :value="cat.id"
              :class="{'is-group': cat._isGroup, 'is-cat': !cat._isGroup}"
              :disabled="cat._isGroup"
            ) {{cat.name}}

        e-form-group(
          name="year"
          inputType="select"
          label="Год"
          @change="yearHandler"
          :model="year"
          :tabView="tabView"
          :options="yearsOptions"
          :disabled="yearDisabled"
        )

        div(
          v-for="(operation, index) in model.operations"
          :key="`count_${index}`"
          v-show="year.year == operation.year"
        )
          e-form-group(
            name="attribute_count"
            inputType="input"
            validationRule="double"
            :label="getAttributeCountLabel"
            :model="model.operations[index]"
            :tabView="tabView"
            :disabled="attributeCountDisabled"
            :validateAlias="`operation.${index}.attribute_count`"
            :validationAdditionalRules="{maxLen:12}"
            :onValidate="onValidate"
          )

      div(
        v-for="(operation, index) in model.operations"
        :key="`month_${index}`"
        v-show="year.year == operation.year"
      ).col
        e-form-subtitle(text="Образовано за месяц")

        e-form-group(
          name="month_kg_plan"
          inputType="input"
          label="План, тонн"
          :model="model.operations[index]"
          :tabView="tabView"
          validationRule="double"
          :disabled="monthOperationDisabled"
          :validateAlias="`operation.${index}.month_kg_plan`"
          :onValidate="onValidate"
        )
        e-form-group(
          name="month_kg_fact"
          inputType="input"
          label="Факт, тонн"
          :model="model.operations[index]"
          :tabView="tabView"
          validationRule="double"
          :disabled="monthOperationDisabled"
          :validateAlias="`operation.${index}.month_kg_fact`"
          :onValidate="onValidate"
        )
        e-form-group(
          name="month_meter_plan"
          inputType="input"
          label="План, куб.м"
          :model="model.operations[index]"
          :tabView="tabView"
          validationRule="double"
          :disabled="monthOperationDisabled"
          :validateAlias="`operation.${index}.month_meter_plan`"
          :onValidate="onValidate"
        )
        e-form-group(
          name="month_meter_fact"
          inputType="input"
          label="Факт, куб.м"
          :model="model.operations[index]"
          :tabView="tabView"
          validationRule="double"
          :disabled="monthOperationDisabled"
          :validateAlias="`operation.${index}.month_meter_fact`"
          :onValidate="onValidate"
        )

      div(
        v-for="(operation, index) in model.operations"
        :key="`year_${index}`"
        v-show="year.year == operation.year"
      ).col
        e-form-subtitle(text="Образовано за год")
        e-form-group(
          name="year_kg_plan"
          inputType="input"
          label="План, тонн"
          :model="model.operations[index]"
          :tabView="tabView"
          validationRule="double"
          :disabled="yearOperationDisabled"
          :validateAlias="`operation.${index}.year_kg_plan`"
          :onValidate="onValidate"
        )
        e-form-group(
          name="year_kg_fact"
          inputType="input"
          label="Факт, тонн"
          :model="model.operations[index]"
          :tabView="tabView"
          validationRule="double"
          :disabled="yearOperationDisabled"
          :validateAlias="`operation.${index}.year_kg_fact`"
          :onValidate="onValidate"
        )
        e-form-group(
          name="year_meter_plan"
          inputType="input"
          label="План, куб.м"
          :model="model.operations[index]"
          :tabView="tabView"
          validationRule="double"
          :disabled="yearOperationDisabled"
          :validateAlias="`operation.${index}.year_meter_plan`"
          :onValidate="onValidate"
        )
        e-form-group(
          name="year_meter_fact"
          inputType="input"
          label="Факт, куб.м"
          :model="model.operations[index]"
          :tabView="tabView"
          validationRule="double"
          :disabled="yearOperationDisabled"
          :validateAlias="`operation.${index}.year_meter_fact`"
          :onValidate="onValidate"
        )

    div(v-if="SHOW_HIDDEN_FIELDS").col.modal__col
      code.col-block нормат для выбр кат planValues: {{planValues}}
      code.col-block последняя получ инфомрация по мо planMO: {{planMO}}
      code.col-block норматив для мкд planMKDValues: {{planMKDValues}}
      code.col-block норматив для индвид planVillageValues: {{planVillageValues}}
      code.col-block уадлось ли получить нормат для мо MORecognized: {{MORecognized}}
</template>

<script>
import { core, garbage, map } from '@/api/api-endpoints'
import { garbageOffline } from '@/api/api-offline-endpoints'
import year from '@/utils/year'
import userFriendlyEr from '@/utils/userFriendlyEr'
import { SHOW_HIDDEN_FIELDS } from '@/config/config'
import { PERMS } from '@/config/permissions'

let Model = (year = null) => ({
  year: year,
  attribute_count: 0,
  month_kg_plan: 0,
  month_meter_plan: 0,
  year_kg_plan: 0,
  year_meter_plan: 0,
  month_kg_fact: 0,
  month_meter_fact: 0,
  year_kg_fact: 0,
  year_meter_fact: 0,
  garbage_summary: 0,
  formed_by_norm: 0,
  formed_by_report: 0,
  summary: {},
})

let Plan = () => ({
  kg_month: 0,
  cub_month: 0,
  kg_year: 0,
  cub_year: 0,
})

export default {
  name: 'garbage-operation',
  props: {
    id: null,
    model: {
      type: Object,
      required: true,
    },
    tabView: {
      type: String,
      default: null,
      required: true,
    },
    onChangeValidation: {
      type: Boolean,
      default: true,
    },
    recalcReportSumOnEditTableDataChange: {
      type: Boolean,
      default: true,
    },
    filterCats: {
      type: Function,
      default: (cats) => {
        return cats
      },
    },
    // (garbage|mkd|village)
    calcAlgo: {
      type: String,
      default: 'garbage',
    },
    geoObjectRecognizeDelay: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      loading: true,
      year: {
        year: year.getCurrentYear(),
      },
      operationError: null,
      collectionError: null,
      MOError: null,
      disableCategory: false,
      showOnlyGroup: 0,
      planMODirty: {},
      MORecognized: false,
    }
  },
  computed: {
    userCanEdit() {
      return this.$store.getters.userCan(PERMS.EDIT, { route: this.$route })
    },
    error() {
      return this.collectionError || this.operationError || this.MOError
    },
    SHOW_HIDDEN_FIELDS() {
      return SHOW_HIDDEN_FIELDS
    },
    categoryDisabled() {
      if (this.model && this.model.id && !this.userCanEdit) {
        return true
      }
      return !(this.disableCategory === false && this.loading === false)
    },
    yearDisabled() {
      return !(this.model.garbage_source_category_id && this.loading === false)
    },
    attributeCountDisabled() {
      return this.yearDisabled !== false
    },
    monthOperationDisabled() {
      return true
    },
    yearOperationDisabled() {
      return true
    },
    getAttributeCountLabel() {
      let title = 'Атрибут расчета норматива'
      if (this.model.garbage_source_category_id && this.garbageCategory) {
        this.garbageCategory.forEach((v) => {
          if (v.id === this.model.garbage_source_category_id) {
            if (v.calculationUnit) {
              title = v.calculationUnit.attribute
            }
          }
        })
      }
      return title
    },
    yearsOptions() {
      return year.getYearsOptions()
    },
    garbageCategory() {
      let tmp = this.$store.getters.readUrlEndpoint(
        this.getGarbageCategoryEndpoint()
      )
      let flatTree = []
      if (tmp && tmp.tree_garbage_category) {
        tmp.tree_garbage_category.forEach(({ group = {}, categories = {} }) => {
          if (
            !this.showOnlyGroup ||
            (this.showOnlyGroup && this.showOnlyGroup === group.id)
          ) {
            flatTree.push(Object.assign(group, { _isGroup: true }))
            for (let key in categories) {
              flatTree.push(categories[key])
            }
          }
        })
      }
      return this.filterCats(flatTree, this.model.garbage_source_type_id)
    },
    planValues() {
      let plan = new Plan()
      this.garbageCategory.forEach((v) => {
        // if (v.year && v.year == this.year.year && v.id == this.model.garbage_source_category_id) {
        // server has data only for 2017 year
        // set taht data for all plan vals
        if (
          v.hasOwnProperty('cub_month') &&
          v.id == this.model.garbage_source_category_id
        ) {
          plan.kg_month = +v.kg_month
          plan.cub_month = +v.cub_month
          plan.kg_year = +v.kg_year
          plan.cub_year = +v.cub_year
        }
      })
      return plan
    },
    planMO() {
      return this.planMODirty
    },
    planMKDValues() {
      return {
        kg_month: +this.planMO.mkd_year_kg_value / 12,
        cub_month: +this.planMO.mkd_year_meter_value / 12,
        kg_year: +this.planMO.mkd_year_kg_value,
        cub_year: +this.planMO.mkd_year_meter_value,
      }
    },
    planVillageValues() {
      return {
        kg_month: +this.planMO.village_year_kg_value / 12,
        cub_month: +this.planMO.village_year_meter_value / 12,
        kg_year: +this.planMO.village_year_kg_value,
        cub_year: +this.planMO.village_year_meter_value,
      }
    },
    needGeoObject() {
      return this.calcAlgo === 'mkd' || this.calcAlgo === 'village'
    },
  },
  watch: {
    model: {
      handler: function () {
        this.recalcAll()
      },
      deep: true,
    },
  },
  methods: {
    onValidate(validationResult) {
      let { error, model } = validationResult
      if (error && model) {
        if (model.year) {
          this.$set(this.year, 'year', +model.year)
        }
      }
      if (this.needGeoObject && !this.MORecognized) {
        validationResult.error =
          'Не удалось определить нормативы для МО. Измените координаты...'
      }
      return validationResult
    },
    catHandler() {
      this.recalcAll()
    },
    setValueIfIsNumber(opIdx, fieldName, value) {
      if (!isNaN(value)) {
        value = value.toFixed(3)
        this.$set(this.model.operations[opIdx], fieldName, value)
      } else {
        this.$set(this.model.operations[opIdx], fieldName, 0)
      }
    },
    calcFormedByReport(opIdx) {
      if (
        this.model.operations[opIdx].garbage_summary &&
        this.recalcReportSumOnEditTableDataChange === false
      ) {
        this.$set(
          this.model.operations[opIdx],
          'formed_by_report',
          this.model.operations[opIdx].garbage_summary
        )
      } else if (
        this.model.operations[opIdx].summary &&
        this.model.operations[opIdx].summary.formed
      ) {
        this.$set(
          this.model.operations[opIdx],
          'formed_by_report',
          this.model.operations[opIdx].summary.formed
        )
      } else {
        if (this.model.operations[opIdx].garbage_summary) {
          this.$set(
            this.model.operations[opIdx],
            'formed_by_report',
            this.model.operations[opIdx].garbage_summary
          )
        } else {
          this.$set(this.model.operations[opIdx], 'formed_by_report', 0)
        }
      }
    },
    recalcAll() {
      this.model.operations.forEach((v, operationIndex) => {
        if (this.calcAlgo === 'mkd') {
          this.recalcMKDorVillage(operationIndex, this.planMKDValues)
        } else if (this.calcAlgo === 'village') {
          this.recalcMKDorVillage(operationIndex, this.planVillageValues)
        } else {
          this.recalc(operationIndex, this.planValues)
        }
      })
    },
    recognizeGeoObjectId() {
      if (this.$store.getters.isGuest) {
        return
      }
      if (this.recognizingGeoObjectId) {
        clearTimeout(this.recognizingGeoObjectId)
      }
      this.MORecognized = false
      this.recognizingGeoObjectId = setTimeout(() => {
        this.$bar.start()
        this.loading = true
        this.MOError = null
        this.MORecognized = false
        const url = map.searchMO()
        this.$store
          .dispatch('createModel', {
            url,
            data: {
              lat: this.model.latitude,
              lng: this.model.longitude,
            },
          })
          .then(({ data }) => {
            this.MOError = null
            if (data && data.id) {
              this.model.geo_object_id = data.id
              this.planMODirty = Object.assign({}, data.plan || {})
              this.MORecognized = true
              this.recalcAll()
            } else {
              this.MORecognized = false
            }
            this.$bar.finish()
            this.loading = false
          })
          .catch((e) => {
            this.MORecognized = false
            this.$bar.finish()
            this.MOError = userFriendlyEr.recognize(e, url)
            this.loading = false
          })
      }, this.geoObjectRecognizeDelay)
    },
    recalc(opIdx, plan) {
      if (opIdx === null) {
        console.error('Unknown operation index')
        return false
      }
      // cub to kg coef
      let q = 0.169
      let count = this.model.operations[opIdx].attribute_count || 0

      this.setValueIfIsNumber(opIdx, 'month_meter_plan', plan.cub_month * count)
      this.setValueIfIsNumber(opIdx, 'year_meter_plan', plan.cub_year * count)
      this.setValueIfIsNumber(
        opIdx,
        'formed_by_norm',
        this.model.operations[opIdx].year_kg_plan / 1000
      )
      // cub to kg
      // ko to ton: https://redmine.etton.ru/issues/13919#note-1
      this.setValueIfIsNumber(
        opIdx,
        'month_kg_plan',
        (plan.cub_month * q * count) / 1000
      )
      // https://redmine.etton.ru/issues/13446#note-22
      // с легкой руки аналитивок теперь это тоны
      this.setValueIfIsNumber(
        opIdx,
        'year_kg_plan',
        (plan.cub_year * q * count) / 1000
      )

      this.calcFormedByReport(opIdx)

      this.setValueIfIsNumber(
        opIdx,
        'year_kg_fact',
        this.model.operations[opIdx].formed_by_report * 1
      ) // * 1000
      this.setValueIfIsNumber(
        opIdx,
        'month_kg_fact',
        this.model.operations[opIdx].year_kg_fact / 12
      )
      this.setValueIfIsNumber(
        opIdx,
        'year_meter_fact',
        this.model.operations[opIdx].year_kg_fact / q
      )
      this.setValueIfIsNumber(
        opIdx,
        'month_meter_fact',
        this.model.operations[opIdx].month_kg_fact / q
      )
      return true
    },
    recalcMKDorVillage(opIdx, plan) {
      if (opIdx === null) {
        console.error('Unknown operation index')
        return false
      }
      // cub to kg coef
      let q = 0.169
      let count = this.model.operations[opIdx].attribute_count || 0

      this.setValueIfIsNumber(opIdx, 'month_meter_plan', plan.cub_month * count)
      this.setValueIfIsNumber(opIdx, 'year_meter_plan', plan.cub_year * count)
      this.setValueIfIsNumber(
        opIdx,
        'formed_by_norm',
        this.model.operations[opIdx].year_kg_plan / 1000
      )
      // cub to kg
      // ko to ton: https://redmine.etton.ru/issues/13919#note-1
      this.setValueIfIsNumber(
        opIdx,
        'month_kg_plan',
        (plan.kg_month * count) / 1000
      )
      // https://redmine.etton.ru/issues/13446#note-22
      this.setValueIfIsNumber(
        opIdx,
        'year_kg_plan',
        (plan.kg_year * count) / 1000
      )

      this.calcFormedByReport(opIdx)

      this.setValueIfIsNumber(
        opIdx,
        'year_kg_fact',
        this.model.operations[opIdx].formed_by_report * 1
      ) // * 1000
      this.setValueIfIsNumber(
        opIdx,
        'month_kg_fact',
        this.model.operations[opIdx].year_kg_fact / 12
      )
      this.setValueIfIsNumber(
        opIdx,
        'year_meter_fact',
        this.model.operations[opIdx].year_kg_fact / q
      )
      this.setValueIfIsNumber(
        opIdx,
        'month_meter_fact',
        this.model.operations[opIdx].month_kg_fact / q
      )
      return true
    },
    update() {
      if (!Array.isArray(this.model.operations)) {
        this.$set(this.model, 'operations', [])
      }

      // set cat from server cats collection
      this.disableCategory = false
      this.garbageCategory.forEach((v) => {
        if (
          v.garbage_source_type_id &&
          v.garbage_source_type_id == this.model.garbage_source_type_id
        ) {
          // set and disable
          if (!v._isGroup) {
            this.$set(this.model, 'garbage_source_category_id', v.id)
            this.disableCategory = true
          } else {
            // select only from group
            this.showOnlyGroup = v.id
            this.disableCategory = false
          }
        }
      })

      // check or create values
      this.yearsOptions.forEach((yOpt) => {
        let iterYear = yOpt.id
        // find or create
        let foundIndex = this.model.operations.findIndex(
          (v) => v.year && v.year === iterYear
        )
        if (foundIndex === -1) {
          this.model.operations.push(new Model(iterYear))
        }
      })

      // init gets and sets
      let model = new Model()
      this.model.operations.forEach((v, foundIndex) => {
        // set default val, for enable vue getters and setters
        for (let fName in model) {
          if (!this.model.operations[foundIndex].hasOwnProperty(fName)) {
            this.$set(this.model.operations[foundIndex], fName, model[fName])
          }
        }
        // if sum null
        if (!this.model.operations[foundIndex].garbage_summary) {
          this.model.operations[foundIndex].garbage_summary = 0
        } else {
          this.$set(
            this.model.operations[foundIndex],
            'formed_by_report',
            this.model.operations[foundIndex].garbage_summary
          )
        }
      })
    },
    yearHandler() {
      this.fetchOperations()
    },
    getGarbageCategoryEndpoint() {
      return core.statuses({ fields: 'tree_garbage_category' })
    },
    calcSummaryOfGarbage(r, inpYear) {
      let sumByYear = {
        [inpYear]: 0,
      }
      if (r && r.data && r.data.data) {
        r.data.data.forEach((v) => {
          let rowYear = v.year || v._year || inpYear
          if (!sumByYear.hasOwnProperty(rowYear)) {
            sumByYear[rowYear] = 0
          }
          sumByYear[rowYear] = sumByYear[rowYear] + +v.formed
        })
      }
      this.model.operations.forEach((v, i) => {
        if (sumByYear.hasOwnProperty(v.year)) {
          this.$set(this.model.operations[i], 'summary', {
            formed: sumByYear[v.year],
          })
        }
      })
    },
    fetchOperations() {
      const year = this.year.year
      const type = 'detail'
      let endpoint = garbageOffline.garbageTable(this.$route.name, year, type)
      if (this.id) {
        endpoint = garbage.garbageOperation({
          query: {
            sourceId: this.id,
            year,
            type,
          },
        })
      }

      this.loading = true
      this.operationError = null
      this.$bar.start()
      this.$store
        .dispatch('updateUrlEndpoint', {
          endpoint,
          offline: !this.id,
          params: {
            disableGlobalError: true,
          },
        })
        .then((r) => {
          this.operationError = null
          this.loading = false
          this.calcSummaryOfGarbage(r, year)
          this.recalcAll()
          this.$bar.finish()
        })
        .catch((e) => {
          this.operationError = userFriendlyEr.recognize(e, endpoint)
          this.loading = false
          this.$bar.finish()
        })
    },
    fetchCollectionData() {
      this.loading = true
      this.collectionError = null
      this.$bar.start()
      const endpoints = [this.getGarbageCategoryEndpoint()]
      return Promise.all(
        endpoints.map((endpoint) =>
          this.$store.dispatch('updateUrlEndpoint', {
            endpoint,
            fromCache: true,
          })
        )
      )
        .then(() => {
          this.collectionError = null
          this.loading = false
          this.update()
          this.$bar.finish()
        })
        .catch((e) => {
          this.loading = false
          this.$bar.finish()
          this.collectionError = userFriendlyEr.recognize(
            e,
            endpoints.join(', ')
          )
        })
    },
    tableEditableStream(data) {
      // for more readable
      if (data && data.action && data.action === 'afterEditRow') {
        if (data.operationType && data.operationType === 'detail') {
          this.fetchOperations()
        }
      }
    },
    coordsStream() {
      this.recognizeGeoObjectId()
    },
    createEditTableListeners() {
      this.operationSubs = this.$emitter.listen(
        'garbage.garbageTable',
        this.tableEditableStream
      )
    },
    createLocationListeners() {
      this.coordsSubs = this.$emitter.listen(
        'e-location.coordinatesChange',
        this.coordsStream
      )
    },
    initEditableLogic() {
      if (this.recalcReportSumOnEditTableDataChange === true) {
        this.fetchOperations()
        this.createEditTableListeners()
      }
    },
    initGeoObjectLogic() {
      if (this.needGeoObject) {
        this.createLocationListeners()
        this.recognizeGeoObjectId()
      }
    },
  },
  destroyed() {
    if (this.operationSubs) {
      this.operationSubs.unsubscribe()
    }
    if (this.coordsSubs) {
      this.coordsSubs.unsubscribe()
    }
  },
  created() {
    this.update()
    this.initEditableLogic()
    this.initGeoObjectLogic()
    this.fetchCollectionData()
  },
}
</script>
